// import { Button, Grid, Paper, TextField } from "@material-ui/core";
// import { makeStyles } from "@material-ui/core/styles";
// import React, { useEffect, useState } from "react";
// import { helpers } from "../../helper/helper";
// import { useSnackbar } from "notistack";
// import { useHistory } from "react-router";
// import { useParams } from "react-router-dom";

// const useStyles = makeStyles((theme) => ({
//   paper: {
//     marginTop: theme.spacing(3),
//     marginBottom: theme.spacing(3),
//     padding: theme.spacing(2),
//     [theme.breakpoints.up(600 + theme.spacing(3) * 2)]: {
//       marginTop: theme.spacing(2),
//       marginBottom: theme.spacing(2),
//       padding: theme.spacing(3),
//     },
//   },
//   submit: {
//     margin: theme.spacing(4, 0, 1, 0),
//   },
//   wrapper: {
//     position: "relative",
//   },
//   buttonProgress: {
//     position: "absolute",
//     top: "50%",
//     left: "91%",
//   },
// }));

// const UpdateCategory = () => {

//   const [name, setName] = useState("");
//   const [category, setCategory] = useState("");
//   const classes = useStyles();
//   const history = useHistory();
//   const id = useParams().id;
//   const { enqueueSnackbar } = useSnackbar();

//   useEffect(() => {
//     getCategory();
//   }, [id]);

//   useEffect(() => {
//     if (Object.keys(category).length > 0) {
//       setName(category?.name);
//     }
//   }, [category]);

//   const getCategory = async () => {
//     const url = `reel/category/${id}`;
//     const result = await helpers.apiCall("GET", url);
//     setCategory(result && result.data && result.data.result ? result.data.result.response : []);
//   };

//   const handleChange = (e) => {
//     setName(e.target.value);
//   };

//   const handleUpdateCategory = async () => {
//     const data = { name };
//     const url = `reel/category/update/${id}`;
//     const result = await helpers.apiCall("PUT", url, data);
//     if (result.status === 200) {
//       setName('');
//       enqueueSnackbar("Updated successfully", {
//         variant: 'success',
//         autoHideDuration: 3000,
//       });
//       history.push("/dashboard/shorts/category")
//     }
//     else {
//       enqueueSnackbar(result.data ? result.data.result.message : result.message, {
//         variant: 'error',
//         autoHideDuration: 3000,
//       });
//       history.push("/dashboard/shorts/category")
//     }
//     setName('');
//   };

//   return (
//     <React.Fragment>
//       <Paper className={classes.paper} square>
//         <div className="card">
//           <div className="card-body">
//             <h4 className="card-title">Add Reel Category Form</h4>
//             <p className="card-description"> Add Reel Category Here </p>
//             <Grid container spacing={3}>
//               <Grid sm={12} xs={12} item>
//                 <TextField
//                   fullWidth
//                   variant="outlined"
//                   id="Category Name"
//                   name="Category Name"
//                   label="Category Name"
//                   value={name}
//                   onChange={handleChange}
//                 />
//               </Grid>
//             </Grid>
//             <Grid align="right" item style={{ marginTop: "10px" }}>
//               <div className={classes.wrapper}>
//                 <Button
//                   variant="contained"
//                   type="submit"
//                   className={classes.submit}
//                   color="primary"
//                   onClick={e => handleUpdateCategory()}
//                 >
//                   Update
//                 </Button>
//               </div>
//             </Grid>
//           </div>
//         </div>
//       </Paper>
//     </React.Fragment>
//   )
// };

// export default UpdateCategory;

import { Button, Grid, Paper, TextField } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React, { useEffect, useState } from "react";
import { helpers } from "../../helper/helper";
import { useSnackbar } from "notistack";
import { useHistory, useParams } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    padding: theme.spacing(2),
    [theme.breakpoints.up(600 + theme.spacing(3) * 2)]: {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
      padding: theme.spacing(3),
    },
  },
  submit: {
    margin: theme.spacing(4, 0, 1, 0),
  },
  wrapper: {
    position: "relative",
  },
  buttonProgress: {
    position: "absolute",
    top: "50%",
    left: "91%",
  },
  errorText: {
    color: "red",
    fontSize: "0.875rem",
  }
}));

const UpdateCategory = () => {
  const [name, setName] = useState("");
  const [category, setCategory] = useState("");
  const [image, setImage] = useState(null); // New state for the selected image
  const [preview, setPreview] = useState(""); // State for image preview
  const [error, setError] = useState(""); // State for error messages
  const classes = useStyles();
  const history = useHistory();
  const { id } = useParams();
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    getCategory();
  }, [id]);

  useEffect(() => {
    if (Object.keys(category).length > 0) {
      setName(category?.name);
    }
  }, [category]);

  // Fetch category details
  const getCategory = async () => {
    const url = `reel/category/${id}`;
    const result = await helpers.apiCall("GET", url);
    setCategory(result && result.data && result.data.result ? result.data.result.response : []);
  };

  const handleChange = (e) => {
    setName(e.target.value);
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      // Validate image dimensions (35x35)
      const img = new Image();
      img.onload = () => {
        // if (img.width !== 35 || img.height !== 35) {
        //   setError("Image must be 35x35 pixels.");
        // } else {
          setError(""); // Clear error if image is valid
          setImage(file); // Set the new image
          const objectUrl = URL.createObjectURL(file);
          setPreview(objectUrl); // Set the preview URL
        // }
      };
      img.src = URL.createObjectURL(file);
    }
  };

  const handleUpdateCategory = async () => {
    const formData = new FormData();
    formData.append("name", name); // Append category name
    if (image) {
      formData.append("reel_catgeory_image", image); // Append image if available
    }

    const url = `reel/category/update/${id}`;
    const result = await helpers.apiCallForm("PUT", url, formData);

    if (result.status === 200) {
      setName(""); // Reset form fields
      setImage(null); // Reset image field after successful update
      setPreview(""); // Reset image preview after successful update
      enqueueSnackbar("Updated successfully", {
        variant: "success",
        autoHideDuration: 3000,
      });
      history.push("/dashboard/shorts/category"); // Redirect after success
    } else {
      enqueueSnackbar(result?.data ? result?.data?.result?.message : result?.message, {
        variant: "error",
        autoHideDuration: 3000,
      });
    }
  };

  return (
    <React.Fragment>
      <Paper className={classes.paper} square>
        <div className="card">
          <div className="card-body">
            <h4 className="card-title">Update Reel Category</h4>
            <p className="card-description"> Update your Reel Category </p>
            <Grid container spacing={3}>
              <Grid sm={12} xs={12} item>
                <TextField
                  fullWidth
                  variant="outlined"
                  id="Category Name"
                  name="Category Name"
                  label="Category Name"
                  value={name}
                  onChange={handleChange}
                />
              </Grid>

              {/* Display the current image if it exists */}
              {category?.image && !image && (
                <Grid sm={12} xs={12} item>
                  <img
                    src={category.image} // Image URL from category data
                    alt="Current Category"
                    style={{ maxWidth: "200px", maxHeight: "200px", objectFit: "cover" }}
                  />
                </Grid>
              )}

              {/* Image preview for newly selected image */}
              {preview && (
                <Grid sm={12} xs={12} item>
                  <img
                    src={preview} // Image preview URL
                    alt="Preview"
                    style={{ maxWidth: "200px", maxHeight: "200px", objectFit: "cover" }}
                  />
                </Grid>
              )}

              {/* Error message if image size is invalid */}
              {error && (
                <Grid sm={12} xs={12} item>
                  <p className={classes.errorText}>{error}</p>
                </Grid>
              )}

              <Grid sm={12} xs={12} item>
                <input
                  accept="image/*" // Allow only image files
                  type="file"
                  onChange={handleImageChange}
                  style={{ display: "none" }}
                  id="image-upload"
                />
                <label htmlFor="image-upload">
                  Upload New Image
                  <Button variant="contained" className="ml-2" component="span" color="primary">
                    Upload
                  </Button>
                </label>
              </Grid>
            </Grid>
            <Grid align="right" item style={{ marginTop: "10px" }}>
              <div className={classes.wrapper}>
                <Button
                  variant="contained"
                  type="submit"
                  className={classes.submit}
                  color="primary"
                  onClick={handleUpdateCategory} // Call the update function
                >
                  Update
                </Button>
              </div>
            </Grid>
          </div>
        </div>
      </Paper>
    </React.Fragment>
  );
};

export default UpdateCategory;
